export default ({ request }) => ({
  listResearchDictionaryTypeApi (data) {
    return request({
      url: '/digitalCenter/research/dictionary/type/list',
      method: 'post',
      data
    })
  },
  saveResearchDictionaryTypeApi (data) {
    return request({
      url: '/digitalCenter/research/dictionary/type/save',
      method: 'post',
      data
    })
  }
})
